import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { map, mergeAll, take } from 'rxjs/operators';
import { Service } from '../interfaces/service.type';
import { AngularFireStorage } from '@angular/fire/storage';
import { ACTIVE } from '../constants/status-constants';
import * as firebase from 'firebase/app';
import { STAFF } from '../constants/member-constant';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { of, pipe } from 'rxjs';
import { Contact } from '../interfaces/contact.type';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  serviceCollection = 'services';
  serviceLikesCollection = 'likes';
  serviceImagePath = '/service';
  followersCollection = 'followers';

  constructor(private afAuth: AngularFireAuth,
    private db: AngularFirestore, private storage: AngularFireStorage, private http: HttpClient) { }

  getAll() {
    return this.db.collection<Service[]>(this.serviceCollection, ref => ref
      .limit(2)
    ).snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  getServices(limit: number = 10, navigation: string = 'first', lastVisible = null, categoryId: string = null, lang: string = 'en') {
    if (!limit) {
      limit = 10;
    }
    let dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
      .where('lang', '==', lang)
      .where('status', '==', ACTIVE)
      .orderBy('published_at', 'desc')
      .limit(limit)
    );
    if (categoryId) {
      if (categoryId.split(' ')[0] !== 'subcategory') {
        dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
          .where('category.id', '==', categoryId)
          .where('lang', '==', lang)
          .where('status', '==', ACTIVE)
          .orderBy('published_at', 'desc')
          .limit(limit)
        );
      } else {
        dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
          .where('topic_list', 'array-contains-any', [categoryId.substring(12)])
          .where('lang', '==', lang)
          .where('status', '==', ACTIVE)
          .orderBy('published_at', 'desc')
          .limit(limit)
        );
      }
    }

    switch (navigation) {
      case 'next':
        if (categoryId) {
          if (categoryId.split[0] !== 'subcategory') {
            dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
              .where('category.slug', '==', categoryId)
              .where('lang', '==', lang)
              .where('status', '==', ACTIVE)
              .orderBy('published_at', 'desc')
              .limit(limit)
              .startAfter(lastVisible));
          } else {
            dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
              .where('topic_list', 'array-contains-any', [categoryId.substring(10)])
              .where('lang', '==', lang)
              .where('status', '==', ACTIVE)
              .orderBy('published_at', 'desc')
              .limit(limit)
              .startAfter(lastVisible));
            break;
          }
        } else {
          dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
            .where('lang', '==', lang)
            .where('status', '==', ACTIVE)
            .orderBy('published_at', 'desc')
            .limit(limit)
            .startAfter(lastVisible));
        }
        break;
    }
    return dataQuery.snapshotChanges().pipe(map(actions => {
      return {
        serviceList: actions.map(a => {

          const data: any = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }),
        lastVisible: actions && actions.length < limit ? null : actions[actions.length - 1].payload.doc
      };
    })
    );
  }

  getAllService(categoryId: string = null, lang: string = 'en', searchValue: string, searchfield) {
    searchValue = searchValue == null ? undefined : searchValue;
    let dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
      .where('category.id', '==', categoryId)
      .where('lang', '==', lang)
      .where('status', '==', ACTIVE)
      .orderBy(searchfield, 'desc')
      .orderBy('published_at', 'desc')
    );

    if (searchValue) {
      dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
        .where(searchfield, '>=', searchValue)
        .where(searchfield, '<=', searchValue + '\uf8ff')
        .where('category.id', '==', categoryId)
        .where('lang', '==', lang)
        .where('status', '==', ACTIVE)
        .orderBy(searchfield, 'desc')
        .orderBy('published_at', 'desc')
      );
    }

    return dataQuery.snapshotChanges().pipe(map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    })
    );
  }

  getServicessub(limit: number = 10, navigation: string = 'first', lastVisible = null, categorySlug: string = null, lang: string = 'en') {
    if (!limit) {
      limit = 10;
    }
    let dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
      .where('lang', '==', lang)
      .where('status', '==', ACTIVE)
      .orderBy('published_at', 'desc')
      .limit(limit)
    );
    if (categorySlug) {
      dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
        .where('topic_list', 'array-contains-any', [categorySlug])
        .where('lang', '==', lang)
        .where('status', '==', ACTIVE)
        .orderBy('published_at', 'desc')
        .limit(limit)
      );
    }

    switch (navigation) {
      case 'next':
        if (categorySlug) {
          dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
            .where('topic_list', 'array-contains-any', [categorySlug])
            .where('lang', '==', lang)
            .where('status', '==', ACTIVE)
            .orderBy('published_at', 'desc')
            .limit(limit)
            .startAfter(lastVisible));
        } else {
          dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
            .where('lang', '==', lang)
            .where('status', '==', ACTIVE)
            .orderBy('published_at', 'desc')
            .limit(limit)
            .startAfter(lastVisible));
        }
        break;
    }
    return dataQuery.snapshotChanges().pipe(map(actions => {
      return {
        serviceList: actions.map(a => {

          const data: any = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }),
        lastVisible: actions && actions.length < limit ? null : actions[actions.length - 1].payload.doc
      };
    })
    );
  }

  getService(slug: string, addRef?: boolean) {
    return this.db.collection<Service>(this.serviceCollection, ref => ref
      .where('slug', '==', slug)
      .limit(1)
    ).snapshotChanges().pipe(take(1),
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          const img = data.image?.url ? data.image?.url : '';
          if (img) {
            data.image.url = img.replace('https://mytrendingstories.com', 'https://assets.mytrendingstories.com');
          }
          return { id, ...data, __doc: addRef ? a.payload.doc : undefined };
        });
      })
    );
  }

  getServiceByServiceId(id: string) {
    return this.db.collection(this.serviceCollection).doc(id).snapshotChanges().pipe(take(1), map(actions => {
      return actions ? actions.payload.data() : null;
    }));
  }

  getServicessearch(limit: number = 10, navigation: string = 'first', lastVisible = null,
    categorySlug: string = null, lang: string = 'en', searchValue: string, searchfield) {
    if (!limit) {
      limit = 10;
    }
    searchValue = searchValue == null ? undefined : searchValue;
    let dataQuery1 = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
      .where(searchfield, '>=', searchValue)
      .where(searchfield, '<=', searchValue + '\uf8ff')
      .where('lang', '==', lang)
      .where('status', '==', ACTIVE)
      .orderBy(searchfield, 'desc')
      .orderBy('published_at', 'desc')
      .limit(limit)
    );
    if (categorySlug) {
      dataQuery1 = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
        .where(searchfield, '>=', searchValue)
        .where(searchfield, '<=', searchValue + '\uf8ff')
        .where('category.slug', '==', categorySlug)
        .where('lang', '==', lang)
        .where('status', '==', ACTIVE)
        .orderBy(searchfield, 'desc')
        .orderBy('published_at', 'desc')
        .limit(limit)
      );
    }

    switch (navigation) {
      case 'next':
        if (categorySlug) {
          dataQuery1 = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
            .where('category.slug', '==', categorySlug)
            .where(searchfield, '>=', searchValue)
            .where('lang', '==', lang)
            .where('status', '==', ACTIVE)
            .orderBy('published_at', 'desc')
            .limit(limit)
            .startAfter(lastVisible));
        } else {
          dataQuery1 = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
            .where('lang', '==', lang)
            .where(searchfield, '>=', searchValue)
            .where('status', '==', ACTIVE)
            .orderBy('published_at', 'desc')
            .limit(limit)
            .startAfter(lastVisible));
          break;
        }
    }

    return dataQuery1.snapshotChanges().pipe(map(actions => {
      return {
        serviceList: actions.map(a => {

          const data: any = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }),
        lastVisible: actions && actions.length < limit ? null : actions[actions.length - 1].payload.doc
      };
    })
    );

  }

  getServiceLikes(serviceId: string) {
    return this.db.collection(this.serviceLikesCollection, ref => ref
      .where('fields.service', '==', serviceId)
    ).snapshotChanges().pipe(map(actions => {
      return actions.length;
    }));
  }

  createContact(serviceId: string, contact: Contact) {
    return new Promise((resolve, reject) => {
      this.http.post(environment.baseAPIDomain + '/api/v1/myservices/' + serviceId + '/contact', contact).subscribe((serviceData) => {
        resolve(serviceData);
      }, (error) => {
        reject(error);
      });
    });
  }

  getRatingByServiceId(serviceId: string) {
    return this.db.collection('rating-mapping', ref => ref.where('docId', '==', serviceId))
      .snapshotChanges()
      .pipe(map((actions: any) => {
        return actions.map((action: any) => {
          const data = action.payload.doc.data();
          const id = action.payload.doc.id;
          return { id, ...data };
        });
      }));
  }

  getRatingServiceByUserId(serviceId: string, userId: string) {
    return this.db.collection('rating-mapping', ref => ref
      .where('docId', '==', serviceId)
      .where('userId', '==', userId)
    ).snapshotChanges()
      .pipe(take(1), map((actions: any) => {
        return actions.map((action: any) => {
          const data = action.payload.doc.data();
          const id = action.payload.doc.id;
          return { id, ...data };
        });
      }));
  }

  createUpdateRating(data: any) {
    return this.db.collection('rating-mapping', ref => ref
      .where('userId', '==', data.userId)
      .where('docId', '==', data.docId)
    ).snapshotChanges().pipe(take(1), map(actions => {
      if (actions.length > 0) {
        this.db.collection('rating-mapping', ref => ref
          .where('userId', '==', data.userId)
          .where('docId', '==', data.docId)).doc(actions[0].payload.doc.id).update(data);
      } else {
        this.db.collection('rating-mapping', ref => ref
          .where('userId', '==', data.userId)
          .where('docId', '==', data.docId)).add(data);
      }
    }));
  }

  getCategoryRow(slug: string, lang: string = 'en', limit: number, afterId?: string) {
    const startAfter = afterId
      ? this.getService(afterId, true).pipe(map(a => a[0].__doc))
      : of(null);

    return startAfter.pipe(
      map(__doc => {
        return this.db.collection<Service[]>(this.serviceCollection, refV => {
          let ref = refV
            .where('category.slug', '==', slug)
            .where('lang', '==', lang)
            .where('status', '==', ACTIVE)
            .limit(limit);

          if (__doc) { ref = ref.startAfter(__doc); }
          return ref;
        }
        ).snapshotChanges();
      }),
      mergeAll(),
      map((actions) => {
        const res = actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        });

        return res;
      })
    );
  }

  getCategory(slug: string, lang: string = 'en') {
    return this.db.collection<Service[]>(this.serviceCollection, ref => ref
      .where('category.slug', '==', slug)
      .where('lang', '==', lang)
      .where('status', '==', ACTIVE)
      .orderBy('published_at', 'desc')
      .limit(30)
    ).snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  getServicesByAuthor(authorId: string, limit: number = 10, navigation: string = 'first', lastVisible = null, type = null) {
    if (!limit) {
      limit = 10;
    }
    let dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
      .where('author.id', '==', authorId)
      .where('status', '==', ACTIVE)
      .orderBy('published_at', 'desc')
      .limit(limit)
    );
    if (type) {
      dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
        .where('author.id', '==', authorId)
        .where('status', '==', ACTIVE)
        .where('type', '==', type)
        .orderBy('published_at', 'desc')

        .limit(limit)
      );
    }
    switch (navigation) {
      case 'next':
        dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
          .where('author.id', '==', authorId)
          .where('status', '==', ACTIVE)
          .orderBy('published_at', 'desc')
          .limit(limit)
          .startAfter(lastVisible));
        if (type) {
          dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
            .where('author.id', '==', authorId)
            .where('status', '==', ACTIVE)
            .where('type', '==', type)
            .orderBy('published_at', 'desc')
            .limit(limit)
            .startAfter(lastVisible));
        }
        break;
    }
    return dataQuery.snapshotChanges().pipe(map(actions => {
      return {
        serviceList: actions.map(a => {

          const data: any = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }),
        lastVisible: actions && actions.length < limit ? null : actions[actions.length - 1].payload.doc
      };
    })
    );
  }

  getServicesByUser(authorId, limit: number = 10, navigation: string = 'first', lastVisible = null) {
    if (!limit) {
      limit = 10;
    }

    let dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
      .where('author.id', '==', authorId)
      .orderBy('created_at', 'desc')
      .limit(limit)
    );

    switch (navigation) {
      case 'next':
        dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
          .where('author.id', '==', authorId)
          .orderBy('created_at', 'desc')
          .limit(limit)
          .startAfter(lastVisible));
        break;
    }
    return dataQuery.snapshotChanges().pipe(map(actions => {
      return {
        serviceList: actions.map(a => {

          const data: any = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }),
        lastVisible: actions && actions.length < limit ? null : actions[actions.length - 1].payload.doc
      };
    })
    );
  }

  getServicesBySlug(limit: number = 10, navigation: string = 'first', lastVisible = null, categorySlug: string = null, topicSlug: string = '', lang: string = 'en') {
    if (!limit) {
      limit = 10;
    }
    let dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
      .where('category.slug', '==', categorySlug)
      .where('lang', '==', lang)
      .where('status', '==', ACTIVE)
      .orderBy('published_at', 'desc')
      .limit(limit));
    if (topicSlug) {
      dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
        .where('category.slug', '==', categorySlug)
        .where('lang', '==', lang)
        .where('status', '==', ACTIVE)
        .where('topic_list', 'array-contains-any', [topicSlug])
        .orderBy('published_at', 'desc')
        .limit(limit)
      );
    }

    switch (navigation) {
      case 'next':
        if (topicSlug) {
          dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
            .where('category.slug', '==', categorySlug)
            .where('lang', '==', lang)
            .where('status', '==', ACTIVE)
            .where('topics_list', 'array-contains-any', [topicSlug])
            .orderBy('published_at', 'desc')
            .limit(limit)
            .startAfter(lastVisible));
        } else {
          dataQuery = this.db.collection<Service[]>(`${this.serviceCollection}`, ref => ref
            .where('category.slug', '==', categorySlug)
            .where('lang', '==', lang)
            .where('status', '==', ACTIVE)
            .orderBy('published_at', 'desc')
            .limit(limit)
            .startAfter(lastVisible));
        }

        break;
    }
    return dataQuery.snapshotChanges().pipe(map(actions => {
      return {
        serviceList: actions.map(a => {

          const data: any = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }),
        lastVisible: actions && actions.length < limit ? null : actions[actions.length - 1].payload.doc
      };
    })
    );
  }

  updateServiceAbuse(serviceId: string) {
    return new Promise<any>((resolve, reject) => {
      this.db.collection(`${this.serviceCollection}`).doc(`${serviceId}`).update({ is_abused: true }).then(() => {
        resolve();
      });
    });
  }

  like(serviceId: string, likerData) {
    const likes = { like: true };
    this.likeCount(serviceId);
    return new Promise<any>((resolve, reject) => {
      this.db.collection(`services/${serviceId}/likes`).doc(likerData.id).set(likes).then(() => {
        resolve();
      });
    });
  }

  disLike(serviceId: string, likerData) {
    this.disLikeCount(serviceId);
    return new Promise<any>((resolve, reject) => {
      this.db.collection(`services/${serviceId}/likes`).doc(likerData).delete().then(() => {
        resolve();
      });
    });
  }

  isLikedByUser(serviceId: string, likerId) {
    return this.db.collection(this.serviceCollection).doc(serviceId).collection(this.serviceLikesCollection).doc(likerId).valueChanges();
  }

  getServiceById(serviceId: string, authorId, type: string) {
    return new Promise<any>((resolve, reject) => {
      this.db.doc(`${this.serviceCollection}/${serviceId}`).valueChanges().subscribe((data) => {
        if (data && data['author'].id === authorId || type === STAFF) {
          data['id'] = serviceId;
          resolve(data);
        } else {
          reject('Unknown entity');
        }
      });
    });
  }

  updateViewCount(serviceId: string) {
    const db = firebase.default.firestore();
    const increment = firebase.default.firestore.FieldValue.increment(1);
    const serviceRef = db.collection(this.serviceCollection).doc(serviceId);
    serviceRef.update({ view_count: increment });
  }

  likeCount(serviceId: string) {
    const db = firebase.default.firestore();
    const increment = firebase.default.firestore.FieldValue.increment(1);
    const serviceRef = db.collection(this.serviceCollection).doc(serviceId);
    serviceRef.update({ likes_count: increment });
  }

  disLikeCount(serviceId: string) {
    const db = firebase.default.firestore();
    const increment = firebase.default.firestore.FieldValue.increment(-1);
    const serviceRef = db.collection(this.serviceCollection).doc(serviceId);
    serviceRef.update({ likes_count: increment });
  }

  deleteService(serviceId) {
    return this.db.collection(this.serviceCollection).doc(serviceId).delete();
  }

  getServiceComments(uid: string, limit: number = 5) {
    return this.db.collection(`${this.serviceCollection}/${uid}/comments`, ref => ref
      .orderBy('published_on', 'desc')
      .limit(limit)
    ).snapshotChanges().pipe(map(actions => {
      return {
        commentList: actions.map(a => {
          const data: any = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }),
        lastCommentDoc: actions && actions.length < limit ? null : actions[actions.length - 1].payload.doc
      };
    })
    );
  }

  getServiceCommentByUser(serviceId: string, userId: string) {
    return this.db.collection(this.serviceCollection).doc(serviceId)
      .collection('comments', ref => ref.where('author.id', '==', userId))
      .snapshotChanges().pipe(take(1), map((item: any) => {
        return item.map(a => {
          const data: any = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }));
  }

  createComment(id: string, commentDtails: Comment) {
    const apicall = environment.baseAPIDomain + '/api/v1/myservices/' + id + '/comments';
    return this.http.post(apicall, commentDtails);
  }

  updateComment(id: string, commentid: string, commentDtails: Comment) {
    return this.http.put(environment.baseAPIDomain + '/api/v1/myservices/' + id + '/comments/' + commentid, commentDtails);
  }

  getServiceCommentNextPage(uid: string, limit: number = 5, lastCommentDoc) {
    if (!limit) {
      limit = 5;
    }
    return this.db.collection(`${this.serviceCollection}/${uid}/comments`, ref => ref
      .orderBy('published_on', 'desc')
      .startAfter(lastCommentDoc)
      .limit(limit)
    ).snapshotChanges().pipe(map(actions => {
      return {
        commentList: actions.map(a => {
          const data: any = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }),
        lastCommentDoc: actions && actions.length < limit ? null : actions[actions.length - 1].payload.doc
      };
    })
    );
  }

  updateServiceCommentAbuse(id: string, commentid: string) {
    return new Promise<any>((resolve, reject) => {
      this.db.collection(`${this.serviceCollection}/${id}/comments`).doc(commentid).update({ is_abused: true }).then(() => {
        resolve();
      });
    });
  }

  followService(serviceId: string, memberDetails: any) {
    const follower: any = {
      id: memberDetails.id,
      fullname: memberDetails.fullname,
      slug: memberDetails.slug,
      type: memberDetails.type ? memberDetails.type : 'member'
    };

    if (memberDetails.avatar) {
      follower.avatar = memberDetails.avatar;
    }

    return new Promise<any>((resolve, reject) => {
      this.db.collection(this.serviceCollection).doc(serviceId).collection(this.followersCollection)
        .doc(memberDetails.id).set({ follower }).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
    });
  }


  unfollowService(serviceId: string, memberDetailsId: any) {
    return new Promise<any>((resolve, reject) => {
      this.db.collection(`${this.serviceCollection}/${serviceId}/${this.followersCollection}`).doc(memberDetailsId).delete().then(() => {
        resolve();
      });
    });
  }

  isUserFollowing(serviceId: string, memberDetailsId: any) {
    return this.db.collection(`${this.serviceCollection}`).doc(serviceId)
      .collection(`${this.followersCollection}`).doc(memberDetailsId);
  }


  getLeadsMonthly(serviceId: string) {
    return this.http.get(environment.baseAPIDomain + `/api/v1/services/${serviceId}/leads/dates`);
  }

  getLeadsOfMonth(serviceId: string, monthId: string) {
    return this.http.get(environment.baseAPIDomain + `/api/v1/services/${serviceId}/leads/${monthId}`);
  }

  createServiceLead(serviceId: string, leadData) {
    return new Promise((resolve, reject) => {
      this.http.post(environment.baseAPIDomain + `/api/v1/services/${serviceId}/leads`, leadData).subscribe((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }

}
